import { gsap } from "gsap";

// run function to set up assigning of animation on page load
$(document).ready(function() {

    if($(".pulse-arrow__wrapper").length) {
        $(".pulse-arrow__wrapper").each( function(i, el) {
            // create a timeline for this element in paused state
            var tl = gsap.timeline({paused: true});

            // get arrow
            var pulse = $(el).find('.pulse-arrow');

            // create tween of the timeline in a variable
            var t = tl
                .from($(pulse).find('.arrow-left'), {duration: 0.3, x: 110})        
                .from($(pulse).find('.heartbeat-line'), {duration: 0.2, scale: 0, transformOrigin:"0 80%"}, 0);
            
            // store the tween timeline in the javascript DOM node
            pulse.animation = t;

            // listen for hover
            $(el).hover(function() {
                pulse.animation.play();
            }, function() {
                pulse.animation.timeScale(2).reverse();
            });
        });
    }

});